<template>
  <div>
    <q-form ref="form">
      <div class="row">
        <div class="col-12">
          <q-select
            v-model="selectedOutcome"
            label="Select Outcome"
            :options="outcomeOptions"
            map-options
            option-label="name"
            emit-value
            @input="outcomeSelect"
            :rules="[(v) => !!v || 'Field is Required']"
          >
          </q-select>
        </div>
        <div class="col-12">
          <q-input
            v-model="formData.description"
            type="textarea"
            label="Description"
          >
          </q-input>
        </div>
        <div class="col-12">
          <q-btn
            v-if="!isUpdating"
            color="primary"
            @click="createNew"
            class="float-right q-mt-sm"
          >
            <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
            <span class="sustainability-font q-mx-sm" style="font-size: 13px">
              New
            </span>
          </q-btn>
          <q-btn
            v-else
            color="primary"
            @click="save"
            class="float-right q-mt-sm"
          >
            <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
            <span class="sustainability-font q-mx-sm" style="font-size: 13px">
              Save
            </span>
          </q-btn>
        </div>
      </div>
    </q-form>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    computed: {
      ...mapGetters({
        outcomesList: "outcomes/list",
        selectedBenefit:
          "solutions/findEntries/featuredEntriesBenefits/selectedBenefit",
      }),
    },
    data: () => ({
      formData: {},
      selectedOutcome: null,
      outcomeOptions: [],
      isUpdating: false,
    }),
    mounted() {
      this.init();
    },

    methods: {
      init() {
        this.outcomeOptions = [];
        this.outcomeOptions = this.outcomesList;
        if (this.outcomeOptions.findIndex((e) => e.id == "123456") <= -1) {
          this.outcomeOptions.push({
            id: "123456",
            name: "Upstream",
          });
        }
        if (this.selectedBenefit) {
          this.isUpdating = true;
          this.formData = JSON.parse(JSON.stringify(this.selectedBenefit));
          if (this.selectedBenefit.customOutcomeTitle == "Upstream") {
            this.selectedOutcome = {
              id: "123456",
              name: "Upstream",
            };
          } else {
            let findOutcome = this.outcomesList.findIndex(
              (e) => e.id == this.selectedBenefit.outcomes_id
            );
            if (findOutcome > -1) {
              this.selectedOutcome = this.outcomesList[findOutcome];
            }
          }
        }
      },
      outcomeSelect() {
        this.formData.customOutcomeImageUrl = null;
        this.formData.customOutcometitle = null;
        this.formData.outcomes_id = null;
        if (this.selectedOutcome.name == "Waste") {
          this.formData.description =
            "We have set up automatic E-Waste data integration in to this software when you use them";
          this.formData.outcomes_id = this.selectedOutcome.id;
        } else if (this.selectedOutcome.name == "Charitable") {
          this.formData.description =
            "Generate a charitable contribution with every transaction at no extra cost to you";
          this.formData.outcomes_id = this.selectedOutcome.id;
        } else if (this.selectedOutcome.name == "Social Procurement") {
          this.formData.description =
            "You are supporting a social enterprise when you use an Upstream Supplier";
          this.formData.outcomes_id = this.selectedOutcome.id;
        } else if (this.selectedOutcome.name == "Upstream") {
          this.formData.description =
            "Is an approved Upstream Supplier so you are supporting a social enterprise";
          this.formData.customOutcomeImageUrl =
            "https://upstreamnz.s3.ap-southeast-2.amazonaws.com/impactBuyerBadges/Approved+Supplier+Badge-01.svg";
          this.formData.customOutcomeTitle = "Upstream";
          this.formData.outcomes_id = null;
        } else {
          this.formData.outcomes_id = this.selectedOutcome.id;
        }
      },
      closeForm() {
        this.$emit("closeForm");
      },
      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          let payload = { ...this.formData };

          let result = await this.$store.dispatch(
            "solutions/findEntries/featuredEntriesBenefits/save",
            {
              ...payload,
            }
          );
          this.closeForm();
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async createNew() {
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          let payload = { ...this.formData };

          let result = await this.$store.dispatch(
            "solutions/findEntries/featuredEntriesBenefits/new",
            {
              ...payload,
              findEntries_id: this.$route.params.featuredFindEntry_id,
            }
          );
          this.closeForm();
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
